import React from 'react';
import { Link } from 'react-router-dom';
import "./Contact_card.css";

function Contact_card() {
    const contactItems = [
        {
            imgSrc: "/assets/images/contact/location.png",
            title: "Location",
            text: [
                "UrbanBuild Technologies Pvt. Ltd. Pune, Maharashtra, India"
            ]
        },

        {
            imgSrc: "/assets/images/contact/email.png",
            title: "Email Address",
            text: [
                "Info.touristjunction@gmail.com"
            ]
        },

        {
            imgSrc: "/assets/images/contact/call.png",
            title: "Phone Number",
            text: [
                "+919607014213"
            ]
        }
    ];

    return (
        <section className='Contact_card'>
            <div className='contact_card_holder'>
                <div className="row justify-content-center">
                    {contactItems.map((item, index) => (
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-5" key={index}>
                            <div className="card_holder">
                                <div className="img_holder">
                                    <img className="logo_img"
                                        src={process.env.PUBLIC_URL + item.imgSrc}
                                        alt="logo" />
                                </div>
                                <div className='text_holder'>
                                    <h4>{item.title}</h4>
                                    {Array.isArray(item.text) ? (
                                        item.text.map((line, i) => (
                                            <p key={i}>{line}</p>
                                        ))
                                    ) : (
                                        <p>{item.text}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Contact_card;
